import React, { useCallback, useEffect, useMemo, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
// Icons
import { Search, Plus, Trash2 } from "lucide-react";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";
import Select from "react-select";

import * as Yup from "yup";
import { useFormik } from "formik";

import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import Swal from "sweetalert2";
import { DEFAULT_CROP_YEAR_ID } from "Common/constants/cropYear";
const YearRegistration = () => {
  const [data, setData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setreload] = useState<boolean>();
  const [load, setload] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState("");
  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [yearCropValue, setYearCropValue] = useState<any>(
    Number(localStorage.getItem("crop_year_id")) || DEFAULT_CROP_YEAR_ID
  );
  const [yearCropList, setYearCropyearCropList] = useState<any>(null);
  const [selectCorp_year, setselectCorp_year] = useState<any>(null);
  const localstorageID = localStorage.getItem("crop_year_id");
  useEffect(() => {
    const getyear = data?.find((items: any) => items.id == localstorageID);
    setselectCorp_year(getyear?.crop_year_name);
  }, [reload, yearCropValue, yearCropList]);

  // Get Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          "https://api.havirkesht.ir/crop-year/?sort_by=updated_at&sort_order=desc"
        );
        const items = res?.data?.items || [];
        setData(items);
        setload(items.length < 0);
      } catch (error: any) {
        console.error("Error fetching data:", error);
        if (error) {
          setErrorMessage(
            "مشکلی در ارتباط با سرور رخ داده است. لطفاً اینترنت خود را بررسی کنید و مطمئن شوید فیلترشکن غیرفعال است."
          );
        } else {
          setErrorMessage("خطایی رخ داده است. لطفاً مجدداً تلاش کنید.");
        }
        setload(true);
      }
    };
    fetchData();
  }, [reload]);
  useEffect(() => {
    // اگر سال زراعی انتخاب شده
    if (yearCropValue) {
      localStorage.setItem(
        "crop_year_id",
        yearCropValue ? yearCropValue : DEFAULT_CROP_YEAR_ID
      );
      return; // از تابع خارج شو
    }
    const storedYear = localStorage.getItem("crop_year_id");
    if (!storedYear) {
      const newYear = yearCropValue;
      if (newYear) {
        localStorage.setItem("crop_year_id", newYear);
        setYearCropValue(newYear);
      }
    }
  }, [yearCropValue]);

  // دریافت سال زراعی
  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        const response = await axios.get(
          "https://api.havirkesht.ir/crop-year/",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const cropYears = response.data?.items || [];
        setYearCropyearCropList(cropYears);
      } catch (error) {
        console.log(error);
        // console.error("خطا در دریافت داده‌ها:", error);
      }
    };

    fetchData();
  }, [reload]);

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.crop_year_name) {
      setEventData(cell.crop_year_name);
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      const res = await axios.delete(
        `https://api.havirkesht.ir/crop-year/${eventData}`
      );
      if (res.status === 200) {
        Swal.fire({
          title: "حذف  سال زراعی",
          text: "عملیات حذف با موفقیت انجام شد",
          icon: "success",
        });
        setreload(!reload);
      } else {
        Swal.fire({
          title: "حذف  سال زراعی",
          text: "عملیات حذف با خطا مواجه شد",
          icon: "error",
        });
      }
      setDeleteModal(false);
      setEventData(null);
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    validation.handleSubmit();
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      crop_year_name: "",
    },
    validationSchema: Yup.object({
      crop_year_name: Yup.string().required("لطفاً نام سال زراعی را وارد کنید"),
    }),
    onSubmit: async (values) => {
      const response = await axios.post(
        "https://api.havirkesht.ir/crop-year/",
        values,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 201) {
        Swal.fire({
          title: "ثبت  سال زراعی",
          text: "عملیات ثبت با موفقیت انجام شد",
          icon: "success",
        });
        setreload(!reload);
      } else {
        Swal.fire({
          title: "ثبت  سال زراعی",
          text: "عملیات ثبت با خطا مواجه شد",
          icon: "error",
        });
      }
      toggle();
    },
  });

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      validation.resetForm();
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  const columns = useMemo(
    () => [
      {
        header: "سال زراعی",
        accessorKey: "crop_year_name",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "تاریخ ایجاد",
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "عملیات",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <Link to="#" onClick={() => onClickDelete(cell.row.original)}>
              <Trash2 className="size-4" />
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ثبت سال زراعی" title="هاویر کشت" />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer
        position="top-center"
        closeButton={false}
        limit={1}
        rtl={true}
        className="font-Bold text-lg"
      />
      {errorMessage && <div>{errorMessage}</div>}
      <div className="card" id="employeeTable rtl">
        <div className="card-body">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 p-2">
            <div className="flex flex-col sm:flex-row items-start sm:items-center w-full md:max-w-[32rem] gap-2 sm:gap-4">
              <label
                htmlFor="year"
                className="text-base font-medium w-full sm:w-32 flex-shrink-0"
              >
                انتخاب سال زراعی:
              </label>
              <Select
                options={yearCropList?.map((data: any) => ({
                  value: data.id,
                  label: data.crop_year_name,
                }))}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  control: (base, state) => ({
                    ...base,
                    backgroundColor: "inherit",
                    boxShadow: state.isFocused
                      ? "0 0 0 1px #2684FF dark:bg-text-gray-300 dark:text-gray-800"
                      : "none",
                  }),
                  option: (base, state) => ({
                    ...base,
                    color: "inherit",
                    "&:hover": {
                      backgroundColor: "#2684FF",
                    },
                  }),
                }}
                onChange={(selected: any) => setYearCropValue(selected.value)}
                onInputChange={(inputValue) => setreload(!reload)}
                menuPortalTarget={document.body}
                placeholder="انتخاب کنید"
                noOptionsMessage={() => "داده‌ای دریافت نشد"}
                loadingMessage={() => "در حال بارگذاری..."}
                className="w-full my-react-select-container"
                classNamePrefix="my-react-select"
                maxMenuHeight={300}
                isSearchable
              />

              <div className="whitespace-nowrap text-red-600">
                {selectCorp_year ? (
                  <div className="whitespace-nowrap text-custom-600">
                    سال زراعی انتخاب شده:{" "}
                    <span className="bold text-topbar-dark dark:text-white">
                      {selectCorp_year}{" "}
                    </span>
                  </div>
                ) : (
                  "لطفا سال زراعی را انتخاب کنید"
                )}
              </div>
            </div>
            <div className="w-full sm:w-auto self-end sm:self-center">
              <Link
                to="#"
                onClick={toggle}
                type="button"
                className="w-full sm:w-auto text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 flex items-center justify-center gap-2"
              >
                <span className="align-middle">ایجاد سال زراعی جدید </span>
                <Plus className="size-4" />
              </Link>
            </div>
          </div>
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={true}
              columns={columns}
              data={data}
              isGlobalFilter={true}
              customPageSize={10}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={data ? 0 : 15}
              text={errorMessage ? errorMessage : "داده ای در جدول وجود ندارد"}
            />
          )}
        </div>
      </div>
      <Modal
        show={show}
        onHide={toggle}
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
        >
          <Modal.Title className="text-16">ایجاد سال زراعی جدید</Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form
            className="create-form"
            id="create-form"
            onSubmit={validation.handleSubmit}
          >
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
              <div className="xl:col-span-11 dark:text-white text-gray-800">
                <div className="flex items-center">
                  <label
                    htmlFor="crop_year_name"
                    className="text-base font-medium mr-2 w-1/4"
                  >
                    سال زراعی :
                  </label>
                  <input
                    type="text"
                    id="crop_year_name"
                    className="form-input text-black font-[12px] "
                    placeholder=" سال زراعی را وارد کنید:"
                    name="crop_year_name"
                    autoComplete="off"
                    onChange={validation.handleChange}
                    value={validation.values.crop_year_name}
                  />
                </div>
                {validation.touched.crop_year_name &&
                  validation.errors.crop_year_name && (
                    <p className="text-red-400 mr-24 mt-2">
                      {validation.errors.crop_year_name}
                    </p>
                  )}
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="flex justify-center p-4 border-t dark:border-zink-500">
          <button
            type="button"
            onClick={handleClick}
            className="px-4 py-2 mt-4 font-bold justify-end text-white bg-blue-500 rounded hover:bg-blue-600"
          >
            ثبت
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default YearRegistration;
